// Display and form-input helpers for coupons, shared by the coupons table and the coupon form.

export const formatRupees = (n) =>
  `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const formatDiscount = (c) =>
  c.discountType === "PERCENTAGE"
    ? `${Number(c.discountValue)}%`
    : formatRupees(c.discountValue);

export const formatDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatValidFrom = (c) => formatDate(c.startDate) ?? "Any time";

export const formatValidTo = (c) => formatDate(c.endDate) ?? "No expiry";

// ISO date-time <-> <input type="datetime-local"> ("YYYY-MM-DDTHH:mm", local time).
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const fromLocalInput = (value) => (value ? new Date(value).toISOString() : undefined);
